<template>
  <div class="mt-12">
    <a class="anchor" id="exhibitionFormTitle"></a>
    <h2 class="text-center text-uppercase">
      <i class="fas fa-square"></i>
      {{ formTitle }}
    </h2>
  </div>
</template>

<script>
export default {
  computed: {
    formTitle() {
      return window.formTitle || this.$i18n.t("form.title");
    }
  }
};
</script>

<style></style>
